import { Component } from '@angular/core';

@Component({
  selector: 'app-ev-loading',
  template: `
  <div class="loader-wrapper fa-2x">
    <i class="fas fa-spinner fa-spin"></i>
  </div>
  `,
  styleUrls: ['./ev-loading.component.scss'],
})
export class EvLoadingComponent {}
